module.exports = __webpack_public_path__ + "contact_info_icon.ba13650945339b829973.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/contact_info_icon.svg
// module id = 447
// module chunks = 0